import React from 'react';

import TradeListHeaderPlaceholder from './HeaderPlaceholder';
import TradeListTablePlaceholder from './TradeListTable/Placeholder';

/**
 * Full-page loading skeleton for the trade history page.
 *
 * Combines the header placeholder (breadcrumbs, title, and filter controls) with the
 * trade table placeholder. Used by the TradeList route error boundary so the page
 * layout stays intact behind the load-failure dialog. The root is `inert` as well as
 * `aria-hidden` because the filter controls skeleton renders real buttons.
 * @returns {React.ReactElement} Header and table placeholders for the trade list page.
 */
function TradeListPlaceholder() {
  return (
    <div aria-hidden="true" inert>
      <TradeListHeaderPlaceholder />
      <TradeListTablePlaceholder />
    </div>
  );
}

export default TradeListPlaceholder;
